import { React, useState, useEffect } from "react";
import { Box } from '@chakra-ui/react';
import { Trash2, Pencil, User, UserX } from "lucide-react";
import SidebarScroll from 'components/scroll/SidebarScroll';
import { QuickAlert } from "theme/components/alerts";
import SimpleDataTable from "views/global/SimpleDataTable";
import SimpleSidebar from "views/global/SimpleSidebar";
import FormGenerate from "views/global/FormGenerate";
import { userController } from 'lib/user';
import handleConfirmation from 'lib/handleConfirmation';
import handleSidebar from "lib/handleSidebar";


function UserManagement() {
    //IMPORT CONTROLLER
    const { setAlert, clearAlert, showAlert } = QuickAlert();
    const {saveRecord, getSingleRecord} = userController();
    const [status, setStatus] = useState({
        sidebarForm: false,
        loading: false,
        formLoading: false,
        saveNewList: false,
        editListEnabled: false
    });
    const [input, setInput] = useState({});
    const fieldNames = [
        {label: "Nome Completo", name:"name", type:"text", required: true},
        {label: "Email", name:"email", type:"email", required: true},
        {label: "Ruolo", name:"role", type:"select", required: true, options: [["Amministratore","admin"],["Ufficio","office"],["Operazioni","operation"],["Manutenzione","maintenance"],["Pulizie","cleaner"]]},
        {label: "Password", name:"password", type:"password", required: true},
        {label: "Conferma Password", name:"password_confirmation", type:"password", required: true},
    ]
    const trigerSaveList = status.saveNewList ? false : true;


    //CHECKBOX MENU
    const checkboxMenu = [
        {
            icon: <Trash2 />,
            name: "Elimina",
            color: "red",
            handle : (checked) => handleConfirmation(checked, "delete", {one: "il membro selezionato", many: "i membri selezionati"}, "L'eliminazione rimuoverà anche tutti i dati associati. Questa azione non può essere annullata.", "/user/management/delete",(response) => {
                clearAlert();
                setStatus(prevStatus => ({
                    ...prevStatus,
                    saveNewList: trigerSaveList,
                }));
                setAlert(response.data.status, response.data.message);
            },
            (error) => {
                setAlert("error",error.response.data.errors);
            }),
        }
    ];

    //CREATE LIST SHOW & HIDE SIDEBAR
    const createList = () => {
        setStatus(prevStatus => ({
            ...prevStatus,
            sidebarForm: true,
            editListEnabled: false
        }));
        setInput({});
        handleSidebar();
    }
    const hideList = () => {
        setStatus(prevStatus => ({
            ...prevStatus,
            sidebarForm: false,
            editListEnabled: false
        }));
        setInput({});
        clearAlert();
        handleSidebar(false);
    }

    //SAVE LIST DETAIL
    const saveListHandle = () => {
        setStatus(prevStatus => ({
            ...prevStatus,
            loading: true,
        }));
        saveRecord('/user/management/create',input).then(response => {
            return response;
        }).then(response => {
            setStatus(prevStatus => ({
                ...prevStatus,
                loading: false,
                saveNewList: trigerSaveList,
            }));
            hideList();
        }).catch(function(error) {
            setStatus(prevStatus => ({
                ...prevStatus,
                loading: false,
            }));
            setAlert("error",error.response.data.errors);
            SidebarScroll();
        });
    }
    //EdIT LIST SAVE
    const editListHandle = (row) => {
        handleSidebar();
        setStatus(prevStatus => ({
            ...prevStatus,
            sidebarForm: true,
            editListEnabled: true,
            formLoading: true
        }));
        getSingleRecord("/user/management/get/"+row.id).then(response => {
            return response;
        }).then(response => {
            setInput((prev) => ({
                ...prev,
                ...response.data.item,
            }));
            setStatus(prevStatus => ({
                ...prevStatus,
                formLoading: false
            }));
        }).catch(function(error) {
            setAlert("error",error.response.data.errors);
            setStatus(prevStatus => ({
                ...prevStatus,
                formLoading: false
            }));
        });
    }
    //HIDE SIDEBAR
    useEffect(() => {
        clearAlert();
    }
    ,[status.sidebarForm, status.editListEnabled]);

    const tableMenuItems = [
        {
            icon: <Pencil />,
            title: "Modifica Membro",
            handle : editListHandle,
        },
        {
            icon: (row) => {
                return row.status === "active" ? <UserX /> : <User />;
            },
            title: (row) => {
                return row.status === "active" ? "Disattiva Membro" : "Attiva Membro";
            },
            handle: (row) => {
                const status = row.status === "active" ? "deactive" : "active";
                const message = row.status === "active" ? "Il membro non potrà più accedere al sistema." : "Il membro potrà accedere al sistema.";
                const ID = {};
                ID[row.id] = true;
                handleConfirmation(ID, status, {one: "questo membro", many: "questi membri"}, message, "/user/management/status",(response) => {
                    clearAlert();
                    setStatus(prevStatus => ({
                        ...prevStatus,
                        saveNewList: trigerSaveList,
                    }));
                    setAlert(response.data.status, response.data.message);
                },
                (error) => {
                    setAlert("error",error.response.data.errors);
                });
            }
        },
    ];

    const actionButtons = [
        {
            title: "Crea Nuovo Membro",
            icon: <User />,
            handle: createList,
        },
    ];

    return (
        <Box>
            {status.sidebarForm===false ? showAlert() : null }
            <SimpleDataTable
                title="Gestione Team"
                buttons={actionButtons}
                src="/user/management/list"
                search={true}
                checkbox={true}
                checkboxMenu={checkboxMenu}
                tableMenu={tableMenuItems}
                trigger={status.saveNewList}
            />
            <SimpleSidebar
            status={status.sidebarForm}
            title={status.editListEnabled ? "Modifica Membro" : "Crea Nuovo Membro"}
            save={{onClick:saveListHandle,isLoading:status.loading,text:status.editListEnabled ? "Aggiorna" : "Crea Membro"}}
            cancel={{onClick:hideList, text:"Annulla"}}
            loading={status.formLoading}
            >
                {status.sidebarForm===false ?  null : showAlert() }
                {status.sidebarForm===true &&
                    <FormGenerate fields={fieldNames} setFields={setInput} defaultValue={input} />
                }
            </SimpleSidebar>
        </Box>

    );
}
export default UserManagement;
